// extracted by mini-css-extract-plugin
export default {"wrapper":"couples-item-like_wrapper__yX2Us","box":"couples-item-like_box__eYfMR","icon":"couples-item-like_icon__I9M8u"};